<template>
	<div class="section" id="header" style="padding-top: 0px">
		<div class="container">
			<div class="columns">
				<div class="column">
					<div class="is-hidden-touch">
						<img src="@/assets/logo.png" class="is-paddingless" />
					</div>
					<div class="is-hidden-desktop">
						<img src="@/assets/logo.png" class="is-paddingless" />
					</div>
				</div>
				<div class="column is-size-7 has-text-right is-hidden-touch">
					<a style="color:#2F4E6F!important;" href="https://www.aesc.org/member/dashboard">Back to AESC Member Site</a>&nbsp;---&nbsp;
					<a style="color:#2F4E6F!important;">Get Help</a>
				</div>
			</div>
			<div class="level" style="border-bottom: solid; border-color: #2F4E6F;margin-bottom: 0px">
				<div id="userCount" v-if="$route.name !== 'results' || $store.getters.search == null || !$store.getters.search.count">
					<div class="level-left" v-if="totalMembers"><p><b>Find Executives - {{TotalMembers}}<!--124,622--> and growing</b></p></div>
				</div>
				<div id="userCount" v-if="$route.name == 'results' && $store.getters.search != null && $store.getters.search.count">
					<p>
						<b>
							<span v-show="!$store.getters.isSearching">
								<span class="mr-3">{{$store.getters.search.count}} Results</span>
								<span><span v-html="$currency.format(Math.round($store.getters.search.averageComp).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','), 0)"></span> average compensation</span>
							</span>
						</b>
					</p>
				</div>
				<div id="buttonsTop" class="is-paddingless">
					<b-button v-bind:class="(!HasPath('/opportunities')) ? 'active' : 'non-active' " @click="$router.push('/')">Search our database</b-button>
					<b-button v-bind:class="(HasPath('/opportunities')) ? 'active' : 'non-active' " @click="$router.push('/opportunities')">Manage Opportunities</b-button>
				</div>
			</div>
			<div class="tabs is-right is-toggle" v-show="IsHome || HasPath('/results') || HasPath('/profile') || HasPath('/saved') || HasPath('/flagged')">
				<ul style="justify-content:flex-start" v-show="HasResults">
					<li><b-button type="is-light" @click="$router.push('/results')" icon-left="arrow-left">Return to search results</b-button></li>
				</ul>
				<ul>
					<li><b-button type="is-light" class="is-fullwidth-mobile" v-show="!IsHome" @click="$router.push('/')">Modify Search</b-button></li>
					<li><b-button type="is-text" class="is-fullwidth-mobile" v-show="HasPath('/results')" @click="resetQuery">Reset Search</b-button></li>
					<li><b-button type="is-text" class="is-fullwidth-mobile" v-show="HasPath('/results')" @click="saveSearch">Save Search</b-button></li>
					<li><b-button type="is-text" class="is-fullwidth-mobile" @click="$router.push('/saved')">Saved Searches</b-button></li>
					<li><b-button type="is-text" class="is-fullwidth-mobile" @click="$router.push('/flagged')">Flagged Profiles</b-button></li>
					<li><b-button type="is-text" class="is-fullwidth-mobile" @click="openChangeCurrency">Change Currency</b-button></li>
				</ul>

			</div>
			<div class="columns">

			</div>
		</div>
	</div>
</template>

<script>
	import changeCurrency from "@/components/modals/changeCurrency.vue";
	import saveSearch from "@/components/modals/saveSearch.vue";
	export default {
		data() {
			return {

			}
		},
		props: {
			totalMembers: {
				type: Number,
				default: undefined
			}
		},
		computed: {
			HasResults() {
				//const hasResults = !!sessionStorage.getItem("BSDBResults");
				return /*hasResults && */this.$route.name !== "results" && this.$route.name !== "Home" && this.$route.name !== "ManageOpportunities";
			},
			TotalMembers() {
				return Intl.NumberFormat().format(this.totalMembers || 0);
			},
			IsHome() {
				if (this.$route.path.endsWith('/'))
					return true;
				else
					return false;
			}
		},
		methods: {
			resetQuery() {
				this.$store.dispatch("setQuery", JSON.parse(JSON.stringify(this.$emptyQuery)));
				this.$store.dispatch("setQueryId", null);
				this.$router.push('/');
			},
			HasPath(path) {
				if (this.$route.path.startsWith(path))
					return true;
				else
					return false;
			},
			saveSearch() {
				this.$buefy.modal.open({
					parent: this,
					component: saveSearch,
					hasModalCard: true,
					canCancel: false,
					props: {
						Search: this.$store.getters.query
					},
					events: {
						'close': async () => {
							await this.$parent.close();
						}
					}
				})
			},
			openChangeCurrency() {
				var currency = { Id: 83 };
				if (localStorage.getItem("BSDBCurrency")) {
					currency = JSON.parse(localStorage.getItem("BSDBCurrency"));
				}

				this.$buefy.modal.open({
					parent: this,
					component: changeCurrency,
					canCancel: false,
					props: {
						currencyId: currency.Id
					},
					events: {
						close: (result) => {
							if (result !== undefined) {
								this.$store.dispatch('setCurrency', result.currency);
								this.$store.dispatch('setXRate', result.rate);
								this.$store.dispatch('setCurrencyRange', result.ranges);
							}
						}
					}
				});
			}
		}
	}
</script>

<style>

	#header .tabs {
		border: none;
	}

	#buttonsTop {
		text-align: right;
	}

	img {
		padding-left: 25px;
	}

	.active {
		color: white;
		border-color: #2F4E6F !important;
		border-radius: 0px !important
	}

		.active:hover {
			color: white;
			background-color: #3c648f !important;
			border-radius: 0px !important
		}

	.non-active {
		color: white;
		border-color: #5279a1 !important;
		background-color: #5279a1 !important;
		border-radius: 0px !important
	}

		.non-active:hover {
			background-color: #618cb8 !important;
		}

	.button:focus:not(:active), .button.is-focused:not(:active) {
		box-shadow: none !important;
	}

	.is-light {
		border-radius: 0px !important;
	}

	.is-text {
		border-radius: 0px !important;
		text-decoration: none !important;
	}

	@media screen and (max-width: 1125px), print {
		.is-fullwidth-mobile {
			display: flex;
			width: 100%;
		}
	}
</style>
